<template>
  <div class="environments">
    <ul>
      <li class="environments-left tc pr20">
        <img
          class="mb10 data-img"
          :src="`${userCommonImageUrlForPc}/company_data_pc.png`"
          alt="environments"
          data-test="environments-img"
        >
        <h3 class="fs15 fwB">
          データで見る<br>働く環境
        </h3>
        <span
          class="fs11"
          data-test="update-date"
        >{{ updateDate | formatDate }}時点</span>
      </li>
      <li class="environments-right pl25">
        <slot />
      </li>
    </ul>
  </div>
</template>
<style scoped lang="scss">
@use "@/styles/preview/pc/offer/base" as *;
</style>

<script>
import dayjs from 'dayjs'
import jobPreviewCommon from '@/lib/jobPreviewCommon'

export default {
  filters: {
    formatDate (date) {
      return date ? dayjs(date).format('YYYY年MM月') : ''
    }
  },
  mixins: [jobPreviewCommon],
  props: {
    updateDate: {
      type: String,
      required: true
    }
  }
}
</script>
